import React from 'react';
import PasswordResetError from "../../components/password-reset/PasswordResetError";

const PasswordResetErrorPage = (props) => (
    <PasswordResetError {...props}/>
);

export default PasswordResetErrorPage;